/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import { defaultLineStyle, defaultFillStyle } from '../constant.js';

var useStyles = function useStyles(styles) {
  var stroke = styles.stroke,
      strokeWidth = styles.strokeWidth,
      strokeLinejoin = styles.strokeLinejoin,
      strokeLinecap = styles.strokeLinecap,
      fillOpacity = styles.fillOpacity,
      fill = styles.fill;
  return {
    lineStyle: {
      stroke: stroke !== null && stroke !== void 0 ? stroke : defaultLineStyle.stroke,
      strokeWidth: strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : defaultLineStyle.strokeWidth,
      strokeLinejoin: strokeLinejoin !== null && strokeLinejoin !== void 0 ? strokeLinejoin : defaultLineStyle.strokeLinejoin,
      strokeLinecap: strokeLinecap !== null && strokeLinecap !== void 0 ? strokeLinecap : defaultLineStyle.strokeLinecap,
      fill: "none"
    },
    fillStyle: {
      stroke: stroke !== null && stroke !== void 0 ? stroke : defaultFillStyle.stroke,
      strokeWidth: 0,
      fillOpacity: fillOpacity !== null && fillOpacity !== void 0 ? fillOpacity : defaultFillStyle.fillOpacity,
      fill: fill !== null && fill !== void 0 ? fill : defaultFillStyle.fill
    }
  };
};

export { useStyles as default };
//# sourceMappingURL=useStyles.js.map
